import React from "react";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa"; // Importing from react-icons/fa
import Logo from "../../components/Logo.jsx";
import "./Navbar.css";

const baseNavLinks = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/about-us" },
  { name: "FAQS", href: "/faqs" },
  { name: "Education", href: "/education" },
];

const mobileExtraLinks = [
  { name: "Contact", href: "/contact-us" },
  { name: "Login", href: "/app" },
];

const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

const navLinks = isMobile
  ? [...baseNavLinks, ...mobileExtraLinks]
  : baseNavLinks;

export default function navbar1() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const location = useLocation();

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
      setIsScrolled(currentScrollPos > 10);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  let navbarBgClass = "";
  if (isHomePage) {
    navbarBgClass = isScrolled ? "navbar1-home-scrolled" : "navbar1-home-top";
  } else {
    navbarBgClass = "navbar1-not-home";
  }

  return (
    <header
      className={`navbar1 ${navbarBgClass} ${
        visible ? "navbar1-visible" : "navbar1-hidden"
      }`}
    >
      <div className="navbar1-container">
        <Link to="/" className="logo-link1">
          <Logo height={"60px"} />
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <div className="nav1-cont">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`nav1-link1 ${
                  location.pathname === link.href ? "nav1-link-active1" : ""
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
          <div className="nav1-buttons">
            <Link to={"/app"} className="nav1-link1">
              Login
            </Link>
            <Link to={"/contact-us"} className="contact-button-link">
              <div
                className="contact-button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                Contact
              </div>
            </Link>
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <FaTimes className="mobile-menu-icon" />
          ) : (
            <FaBars className="mobile-menu-icon" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`mobile-nav ${
          isMenuOpen ? "mobile-nav1-open" : "mobile-nav1-closed"
        }`}
      >
        <nav className="mobile-nav1-container">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className={`mobile-nav1-link ${
                location.pathname === link.href ? "mobile-nav1-link-active" : ""
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
